import {
	BathtubOutlined,
	ConstructionOutlined,
	DeckOutlined,
	FoundationOutlined,
	GarageOutlined,
	HexagonOutlined,
	KingBedOutlined,
	KitchenOutlined,
	LandscapeOutlined,
	RoofingOutlined,
} from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

// Icon for an owner adjustment type ("Kitchen", "Full Renovation", ...), shared by the adjustments
// list and the add form. Unknown types get a neutral shape.
export function AdjustmentIcon(props: { type?: string } & SvgIconProps) {
	const { type, ...iconProps } = props;
	const key = (type ?? "").toLowerCase().trim().replace(" ", "");
	switch (key) {
		case "bedroom":
			return <KingBedOutlined {...iconProps} />;
		case "kitchen":
			return <KitchenOutlined {...iconProps} />;
		case "bathroom":
			return <BathtubOutlined {...iconProps} />;
		case "garage":
			return <GarageOutlined {...iconProps} />;
		case "landscaping":
			return <LandscapeOutlined {...iconProps} />;
		case "roofing":
			return <RoofingOutlined {...iconProps} />;
		case "deck":
			return <DeckOutlined {...iconProps} />;
		case "newbuild":
			return <ConstructionOutlined {...iconProps} />;
		case "fullrenovation":
			return <FoundationOutlined {...iconProps} />;
		default:
			return <HexagonOutlined {...iconProps} />;
	}
}
